import { Glue42Office } from "../glue4office";
import { InternalConfig, LibConfigObject } from "./types";

interface InputModeObject {
    mode?: boolean | string;
}

declare var global: any;

export default (options: Glue42Office.Config): InternalConfig => {

    // Possible options per lib (this is InputLibConfig type)
    // * false - library is disabled (e.g. config.appManager = false)
    // * true - library is enabled in running in default mode (e.g config.appManager = true).
    //          Exception is if default mode is false - in that case it runs default true mode.
    // * string - start in some mode (e.g. config.appManager = "full")
    // * object - allows further customization (e.g config.appManager = {mode: "full", someSetting: 42})
    //
    // Some libs support different running modes, some do not.
    //
    // Currently defaults are:
    // appManager: disabled
    // layouts: enabled in 'slim' mode
    // activities: enabled in 'trackMyTypeAndInitiatedFromMe' mode
    // windows: enabled (does not support modes)
    // contexts: enabled (does not support modes)
    //
    // InputLibConfig is transformed to LibConfigObject

    type InputLibConfig = boolean | string | InputModeObject;

    /**
     * Transforms InputLibConfig (the config as specified from the user)
     * to LibConfigObject(internal library configuration)
     */
    function getLibConfig<T extends LibConfigObject>(value: InputLibConfig,
                                                     defaultMode: boolean | string,
                                                     trueMode?: boolean | string): T {

        // if value is false return undefined
        if (typeof value === "boolean" && !value) {
            return undefined;
        }

        // find the mode of the library
        const mode = getModeAsString(value, defaultMode, trueMode);

        // if object we will replace the mode because appManager = {mode: true, setting: 42}
        // should be turned into appManager = {mode: 'slim', setting: 42}
        if (typeof value === "object") {
            value.mode = mode;
            return value as T;
        }

        return {
            mode,
        } as T;
    }

    /**
     * Finds the mode based for a given library
     * 1. If object we call recursively using object.mode for value
     * 1. If the user hasn't specified anything we use the hard coded defaults
     * 3. If the value is false or it got defaulted to false, we return undefined
     * 4. If the value is true we return trueMode or defaultMode (if trueMode is undefined)
     */
    function getModeAsString(value: InputLibConfig,
                             defaultMode: boolean | string,
                             trueMode?: boolean | string): string {

        // 1. if object
        if (typeof value === "object") {
            return getModeAsString(value.mode, defaultMode, trueMode) + "";
        } else if (typeof value === "undefined") {
            // 2. if the user does not pass anything

            // 3. if gets defaulted to false, the library should be off
            if (typeof defaultMode === "boolean" && !defaultMode) {
                return undefined;
            } else {
                return defaultMode + "";
            }
        } else if (typeof value === "boolean") {
            // 4. if the user passes true, use trueMode or defaultMode
            if (value) {
                // if the user passes true, use trueMode or defaultMode
                return ((trueMode === undefined) ? defaultMode : trueMode) + "";
            } else {
                 // 3. if the user passes false, the library should be off
                return undefined;
            }
        }

        return value + "";
    }

    return {
        outlook: getLibConfig<LibConfigObject>(options.outlook, true),
        excel: getLibConfig<LibConfigObject>(options.excel, true),
        word: getLibConfig<LibConfigObject>(options.word, true),
    };
};
